<template>
  <header>{{ headerTitleList }}</header>
</template>

<script>
export default {
	computed: {
		headerTitleList() {
			const Title = {
			'home':'あなたの支援金',
			'Diag':'あなたの給付金診断ツール'
			}
			return Title[this.$route.name]
		}
	},
}
</script>

<style scoped>
header {
  padding: 1em;
  font-size: 1.2em;
  text-align: center;
  color: #fff;
  background-color: var(--main-color);
}
</style>